import * as React from "react";
import {option, Option} from "ts-option";
import AssetSpecification from "../../../../model/asset/AssetSpecification";
import DropDown from "../../../../hiberUiKit/src/molecules/DropDown/DropDown";
import DictionaryItem from "../../../../model/dictionary/DictionaryItem";

interface IProps {
	/**
	 * Item asset to edit
	 */
	item: AssetSpecification;
	/**
	 * On asset value change callback.
	 * @param value
	 */
	onChange: (value: Option<string>) => void;
}

export default class AssetSpecificationBooleanSelector extends React.Component<IProps, {}> {

	constructor(props: IProps) {
		super(props);
	}

	render() {
		const currentValue = AssetSpecificationBooleanSelector.getCurrentValue(this.props.item.value);
		const items = [
			new DictionaryItem("true", "Yes"),
			new DictionaryItem("false", "No"),
		];
		if (typeof currentValue === "string") {
			items.unshift(new DictionaryItem(currentValue, currentValue))
		}

		return (
			<div className={"c-assets-boolean"}>
				<div className={"c-assets-boolean_title"}>{this.props.item.label}</div>
				<div className={"c-assets-boolean_item"}>
					<DropDown items={items}
							  itemToId={(item: DictionaryItem) => item.id}
							  itemToLabel={(item: DictionaryItem) => item.name}
							  selectedItemId={currentValue.toString()}
							  onSelect={(value: DictionaryItem) => this.props.onChange(option(value.id))}/>
				</div>
			</div>
		);
	}

	static getCurrentValue(value: string) {
		switch (value) {
			case "true":
				return true;
			case "false":
				return false;
			default:
				return value
		}
	}
}